import { render, staticRenderFns } from "./UnrelevantSusaTable.vue?vue&type=template&id=5be4da4e&scoped=true"
import script from "./UnrelevantSusaTable.vue?vue&type=script&lang=js"
export * from "./UnrelevantSusaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be4da4e",
  null
  
)

export default component.exports